<template>
    <p-modal v-if="display">
        <div slot="content">
            <div class="title">
                獲得獎勵！
            </div>
            <div class="subtitle">
                推薦任務完成，獎勵已存入您的帳號
            </div>
            <div class="content">
                <img src="@/assets/img/gift.png">
            </div>
        </div>
        <div slot="buttons" class="buttons">
            <div class="cancel button" @click="onCancel">
                Ok
            </div>
            <div class="confirm button" @click="onConfirm">
                查看獎勵
            </div>
        </div>
    </p-modal>
</template>

<script>
    import Modal from './Modal';
    export default {
        name: 'HasRecommendGiftModal',
        components: {
            'p-modal': Modal,
        },
        data() {
            return {
                display: false,
            };
        },
        methods: {
            onConfirm() {
                this.display = false;
                this.$router.push({name: 'coupons'});
                this.$emit('onConfirm');
            },
            onCancel() {
                this.display = false;
                this.$emit('onCancel');
            },
            show() {
                this.display = true;
            },
        }
    };
</script>

<style lang="scss" scoped>
    .title {
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;
    }

    .subtitle {
        color: rgba(120,120,120,1);
        font-family: "PingFang TC";
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        margin-top: 5px;
    }

    .content {
        img {
            width: 160px;
            height: auto;
        }
    }

    .buttons {
        display: flex;

        .button {
            width: calc(50% - 1px);
            font-family: "PingFang TC";
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            padding: 12px 0;

            &.cancel {
                color: rgba(155,155,155,1);
            }

            &.confirm {
                color: #339933;
            }

            &:first-child {
                border-right: solid 1px rgba(221,221,221,1);
            }
        }
    }
</style>
